import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { gospelPageSections, siteMeta } from "../data/siteContent";

function GospelPage() {
  return (
    <>
      <PageHero
        eyebrow="The Gospel"
        title="The Greatest News You Will Ever Hear"
        intro="The Christian message is not self-help, moral improvement, or religious performance. It is the good news of what God has done through Jesus Christ for sinners."
        metaTitle={`The Gospel | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container className="narrow-container">
          {gospelPageSections.map((section, index) => (
            <article key={section.title} className="story-step">
              <span>{String(index + 1).padStart(2, "0")}</span>
              <div>
                <h2>{section.title}</h2>
                <p>{section.text}</p>
              </div>
            </article>
          ))}
          <div className="callout-box">
            <h3>Do You Want to Know More About Jesus?</h3>
            <p>
              We would be glad to speak with you, pray with you, and help you understand the
              message of Christ more clearly.
            </p>
            <div className="button-row">
              <Link to="/contact" className="site-button site-button--primary">
                Talk With Us
              </Link>
              <Link to="/visit" className="site-button site-button--secondary">
                Visit Our Church
              </Link>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default GospelPage;
